module.exports = __webpack_public_path__ + "static/media/1.2e568c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobileOmBoarding/1.png
// module id = 930
// module chunks = 21